import Phone from '../../../../../shared/Phone'
import PrequalContactPhoneLinkContainer from './PrequalContactPhoneLinkContainer'

export default PrequalContactPhoneLinkContainer(Phone)
